import React from "react";
import { Button, Col, Row, Form, Space, Card } from "antd";
import {SearchOutlined,EditOutlined} from '@ant-design/icons'
export default function NewFormComponent({
  title,
  form,
  isLoading,
  reset,
  children,
  customAction,
  validate,
  initialValues,
  customActionJustify,
  hideActions,
  layout,
  setFormValues,
  extra
}) {

    const handleFormData = (values) => {
        if (setFormValues) {
            setFormValues(values); // Pass values to parent
        }
      };

  return (
    <Card title={title} bordered={false} extra={extra}>
      <Form
        form={form}
        layout={layout || "vertical"}
        autoComplete="off"
        onValuesChange={(change, values) => {
            handleFormData(values)
            if (validate) {
              validate(change, values);
            }
          }}
        initialValues={initialValues}
        
        // validateTrigger={['onBlur']}
      >
        {children}
        {!hideActions && (
          <Row gutter={[10, 0]} className={`justify-end mt-2`}>
            {/* {customAction ? customAction : <div></div>} */}
            <Space>
              {customAction && customAction}
              {reset !== false && (
                <Col>
                  <Button htmlType="reset" danger>
                    {reset || "Reset"}
                  </Button>
                </Col>
              )}
            </Space>
          </Row>
        )}
      </Form>
    </Card>
  );
}
